const state = {
  locationInfo: JSON.parse(localStorage.getItem('locationInfo')) || {
    text: '我的位置',
    // lon: 115.9518986,
    // lat: 39.0662797,
    lon: 0,
    lat: 0,
    isGps: 0,
    // 1 代表地上，0代表地下
    // 楼层 1：B1，-1：F1， -100: 地上地下切换时的过道
    flag: -1
  },
  mapOptions: {
    token: '',
    bdid: '',
    floorId: ''
  },
  historyList: JSON.parse(localStorage.getItem('searchHistory')) || [],
  poiInfo: JSON.parse(localStorage.getItem('poiInfo')) || {},
  routePath: JSON.parse(localStorage.getItem('routePath')) || {},
  naviState: -1,
  // -1 未导航, 0 导航中, 1 退出导航, 3 导航结束, 4 暂停导航
  // 0 未导航, 1 导航中, 2 导航结束
  amapNaviState: JSON.parse(localStorage.getItem('amapNaviState')) || 0,
  exitLock: !!localStorage.getItem('exitLock') || false,
  // 当前导航进度
  naviStep: JSON.parse(localStorage.getItem('naviStep')) || 1,
  // 室内导航信息
  indoorNaviInfo: JSON.parse(localStorage.getItem('indoorNaviInfo')) || {
    // totalLength: 142.94082089367262,
    // remainDistance: 99,
    // remainTime: '1分钟59秒',
    // distanceToNext: 58.96926402933562,
    // nextInstuction: '左转',
    // segmentIndex: 3,
    // floorId: 'DX0002910100100001',
    // grayT: 0.3131054832581017
  },
  locationShares: [
    // {
    //   app_uid: 4,
    //   nickname: '666',
    //   logo_url: 'location_01HE4RBCB82K1DS7740ETQK7FB.jpg',
    //   building_id: '',
    //   floor_id: '',
    //   lon_lat: '115.942465,39.073311',
    //   timestamp: 1698837507
    // },
    // {
    //   app_uid: 3,
    //   nickname: '1235',
    //   logo_url: 'location_01HE55DHVZ79DSHKTV7HD8NRE3.jpg',
    //   building_id: '',
    //   floor_id: '',
    //   lon_lat: '115.942476,39.073347',
    //   timestamp: 1698837505
    // }
  ]
};
const mutations = {
  SET_LOCATION_INFO(state, info) {
    state.locationInfo = JSON.parse(JSON.stringify(info));
    localStorage.setItem('locationInfo', JSON.stringify(info));
  },
  SET_MAP_OPTIONS(state, options) {
    state.mapOptions = options;
  },
  SET_HISTORY_LIST(state, data) {
    state.historyList = data;
    localStorage.setItem('searchHistory', JSON.stringify(data));
  },
  SET_POI_INFO(state, info) {
    state.poiInfo = info;
    localStorage.setItem('poiInfo', JSON.stringify(info));
  },
  SET_ROUTE_PATH(state, routePath) {
    state.routePath = routePath;
    localStorage.setItem('routePath', JSON.stringify(routePath));
  },
  SET_NAVISTATE(state, naviState) {
    state.naviState = naviState;
    localStorage.setItem('naviState', JSON.stringify(naviState));
  },
  SET_AMAP_NAVISTATE(state, amapNaviState) {
    state.amapNaviState = amapNaviState;
    localStorage.setItem('amapNaviState', JSON.stringify(amapNaviState));
  },
  SET_EXIT_LOCK(state, exitLock) {
    state.exitLock = exitLock;
    localStorage.setItem('exitLock', exitLock);
  },
  SET_NAVISTEP(state, naviStep) {
    state.naviStep = naviStep;
    localStorage.setItem('naviStep', JSON.stringify(naviStep));
  },
  SET_INDOOR_NAVI_INFO(state, indoorNaviInfo) {
    state.indoorNaviInfo = indoorNaviInfo;
    localStorage.setItem('indoorNaviInfo', JSON.stringify(indoorNaviInfo));
  },
  SET_LOCATION_SHARES(state, locationShares) {
    state.locationShares = locationShares;
    localStorage.setItem('locationShares', JSON.stringify(locationShares));
  }
};
const actions = {
  // 设置LocationInfo
  setLocationInfo({
    commit
  }, info) {
    commit('SET_LOCATION_INFO', info);
  },
  setMapOptions({
    commit
  }, options) {
    commit('SET_MAP_OPTIONS', options);
  },
  setHistoryList({
    commit
  }, data) {
    commit('SET_HISTORY_LIST', data);
  },
  setPoiInfo({
    commit
  }, info) {
    commit('SET_POI_INFO', info);
  },
  setRoutePath({
    commit
  }, routePath) {
    commit('SET_ROUTE_PATH', routePath);
  },
  setNaviState({
    commit
  }, naviState) {
    commit('SET_NAVISTATE', naviState);
  },
  setAmapNaviState({
    commit
  }, amapNaviState) {
    commit('SET_AMAP_NAVISTATE', amapNaviState);
  },
  setExitLock({
    commit
  }, exitLock) {
    commit('SET_EXIT_LOCK', exitLock);
    setTimeout(() => {
      commit('SET_EXIT_LOCK', false);
    }, 10000);
  },
  setNaviStep({
    commit
  }, naviStep) {
    commit('SET_NAVISTEP', naviStep);
  },
  setIndoorNaviInfo({
    commit
  }, indoorNaviInfo) {
    commit('SET_INDOOR_NAVI_INFO', indoorNaviInfo);
  },
  setLocationShares({
    commit
  }, locationShares) {
    commit('SET_LOCATION_SHARES', locationShares);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};